import { style } from '@vanilla-extract/css';

export const updatePasswordElement = style({
  margin: '0 auto',
});

export const input = style({
  border: 'none',
  outline: 'none',
  // tailwind adds input[type=email] background-color: fff; so we need to override it
  backgroundColor: 'var(--input-background-color) !important',
  '::placeholder': {
    color: 'var(--placeholder-color)',
  },
});

export const button = style({
  fontFamily: 'var(--button-font-family)',
});

export const icon = style({});
